import {RESTRICTED} from '@core/helpers/constants';
import {
  getAllowedApplicationDataUsers,
  getAllowedAdmins,
  getAllowedOps,
  getAllowedOpsBlacklist,
  getAllowedOpsCollection,
  getCountryCodeFromUrl,
  getTheme,
} from '@shared/api/api';
import store from '@store';
import {lazy} from 'react';

const ROUTES = [
  {
    path: '/login',
    exact: true,
    component: lazy(() => import('../pages/Login')),
    name: 'LoginPage',
    isPrivate: false,
    countries: ['MY', 'ID', 'TH'],
  },
  // {
  //   path: '/loginform',
  //   exact: true,
  //   component: lazy(() => import('../pages/LoginTest')),
  //   name: 'LoginTestPage',
  //   isPrivate: false,
  // countries: ['MY', 'ID', 'TH'],
  // },
  {
    path: '/',
    exact: true,
    component: lazy(() => import('../pages/Dashboard')),
    name: 'DashboardPage',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/view_download_ctp_applications',
    exact: true,
    component: lazy(() => import('../pages/CtpView')),
    name: 'CtpViewPage',
    isPrivate: true,
    countries: ['MY'],
  },
  {
    path: '/download_application_data',
    exact: true,
    component: lazy(() => import('../pages/DownloadApplicationData')),
    name: 'DownloadApplicationData',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
    admin: getAllowedApplicationDataUsers(),
  },
  {
    path: '/view_download_disbursement_ready_applications',
    exact: true,
    component: lazy(() => import('../pages/ViewDisbursement')),
    name: 'ViewDisbursement',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/upload_ctp_application_result',
    exact: true,
    component: lazy(() => import('../pages/UploadCtp')),
    name: 'UploadCtp',
    isPrivate: true,
    countries: ['MY'],
  },
  {
    path: '/upload_disbursement_result',
    exact: true,
    component: lazy(() => import('../pages/UploadDisbursement')),
    name: 'UploadDisbursement',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/view_kyc_applications',
    exact: true,
    component: lazy(() => import('../pages/KycView')),
    name: 'KycView',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/view_kyc_applications/:id',
    exact: true,
    component: lazy(() => import('../pages/ApplicationDetails')),
    name: 'ApplicationDetails',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/view_lender_applications',
    exact: true,
    component: lazy(() => import('../pages/LenderDecisionView')),
    name: 'LenderDecisionView',
    isPrivate: true,
    countries: ['ID'],
  },
  {
    path: '/view_lender_applications/:id',
    exact: true,
    component: lazy(() => import('../pages/ApplicationDetails')),
    name: 'LenderDecisionDetails',
    isPrivate: true,
    countries: ['ID'],
  },
  {
    path: '/upload_merchant_data',
    exact: true,
    component: lazy(() => import('../pages/UploadMerchantData')),
    name: 'UploadMerchantData',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/upload_bank_statement',
    exact: true,
    component: lazy(() => import('../pages/BankStatementUpload')),
    name: 'BankStatementUpload',
    isPrivate: true,
    countries: ['MY'],
  },
  {
    path: '/view_start_repayment_instruction',
    exact: true,
    component: lazy(() => import('../pages/RepaymentInstruction')),
    name: 'RepaymentInstruction',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/view_stop_repayment_instruction',
    exact: true,
    component: lazy(() => import('../pages/StopRepaymentInstruction')),
    name: 'StopRepaymentInstruction',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/upload_repayment_transactions',
    exact: true,
    component: lazy(() => import('../pages/UploadRepaymentTransactions')),
    name: 'UploadRepaymentTransactions',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/view_merchant_limits',
    exact: true,
    component: lazy(() => import('../pages/ViewMerchantLimits')),
    name: 'ViewMerchantLimits',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/view_refund_list',
    exact: true,
    component: lazy(() => import('../pages/ViewRefundList')),
    name: 'ViewRefundList',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/upload_enrollment',
    exact: true,
    component: lazy(() => import('../pages/UploadEnrollment')),
    name: 'UploadEnrollment',
    isPrivate: true,
    countries: ['MY'],
  },
  {
    path: '/upload_refund_result',
    exact: true,
    component: lazy(() => import('../pages/UploadRefundResult')),
    name: 'UploadRefundResult',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/new_limit_override',
    exact: true,
    component: lazy(() => import('../pages/NewLimitOverride')),
    name: 'NewLimitOverride',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
    admin: getAllowedAdmins(),
  },
  {
    path: '/override_new_limit',
    exact: true,
    component: lazy(() => import('../pages/OverrideNewLimit')),
    name: 'OverrideNewLimit',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
    admin: getAllowedAdmins(),
  },
  {
    path: '/preview_new_limit_override',
    exact: true,
    component: lazy(() => import('../pages/NewLimitPreview')),
    name: 'NewLimitPreview',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
    admin: getAllowedAdmins(),
  },
  {
    path: '/topup_limit_override',
    exact: true,
    component: lazy(() => import('../pages/TopupLimitOverride')),
    name: 'TopupLimitOverride',
    isPrivate: true,
    countries: ['MY'],
    admin: getAllowedAdmins(),
  },
  {
    path: '/override_topup_limit',
    exact: true,
    component: lazy(() => import('../pages/OverrideTopupLimit')),
    name: 'OverrideTopupLimit',
    isPrivate: true,
    countries: ['MY'],
    admin: getAllowedAdmins(),
  },
  {
    path: '/update_expected_first_repayment_date',
    exact: true,
    component: lazy(() => import('../pages/UpdateExpectedFirstRepaymentDate')),
    name: 'UpdateExpectedFirstRepaymentDate',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
    admin: getAllowedOps(),
  },
  {
    path: '/collections',
    exact: true,
    component: lazy(() => import('../pages/Collections')),
    name: 'Collections',
    isPrivate: true,
    countries: ['MY'],
    admin: getAllowedOpsCollection(),
  },
  {
    path: '/collections/create_link',
    exact: true,
    component: lazy(() => import('../pages/Collections/components/CreateLink')),
    name: 'CollectionsCreateLink',
    isPrivate: true,
    countries: ['MY'],
    admin: getAllowedOpsCollection(),
  },
  {
    path: '/collections/view_link_status',
    exact: true,
    component: lazy(
      () => import('../pages/Collections/components/ViewLinkStatus')
    ),
    name: 'CollectionsViewLinkStatus',
    isPrivate: true,
    countries: ['MY'],
    admin: getAllowedOpsCollection(),
  },
  {
    path: '/collections/send_ondemand_dd_collection_requests',
    exact: true,
    component: lazy(
      () => import('../pages/Collections/components/OnDemandDDCollection')
    ),
    name: 'CollectionsOnDemandDDCollection',
    isPrivate: true,
    countries: ['MY'],
    admin: getAllowedOpsCollection(),
  },
  {
    path: '/collections/credit_pocket_dd_mandate',
    exact: true,
    component: lazy(
      () => import('../pages/Collections/components/CreditPocketDDMandate')
    ),
    name: 'CollectionsCreditPocketDDMandate',
    isPrivate: true,
    countries: ['MY'],
    admin: getAllowedOpsCollection(),
  },
  {
    path: '/collections/backup_dd',
    exact: true,
    component: lazy(() => import('../pages/Collections/components/BackupDD')),
    name: 'CollectionsBackupDD',
    isPrivate: true,
    countries: ['MY'],
    admin: getAllowedOpsCollection(),
  },
  {
    path: '/banner_management',
    exact: true,
    component: lazy(() => import('../pages/BannerManagement')),
    name: 'BannerManagement',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/banner_management/create_campaign',
    exact: true,
    component: lazy(
      () => import('../pages/BannerManagement/components/CreateCampaign')
    ),
    name: 'BannerManagementCreateCampaign',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/banner_management/edit_campaign/:id',
    exact: true,
    component: lazy(
      () => import('../pages/BannerManagement/components/EditCampaign')
    ),
    name: 'BannerManagementdEditCampaign',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/blacklist_management',
    exact: true,
    component: lazy(() => import('../pages/BlacklistManagement')),
    name: 'BlacklistManagement',
    isPrivate: true,
    countries: ['MY'],
    admin: getAllowedOpsBlacklist(),
  },
  {
    path: '/rejection_list',
    exact: true,
    component: lazy(() => import('../pages/RejectionList')),
    name: 'RejectionList',
    isPrivate: true,
    countries: ['MY'],
  },
  {
    path: '/loan_status_board',
    exact: true,
    component: lazy(() => import('../pages/OpsBoard')),
    name: 'OpsBoard',
    isPrivate: true,
    countries: ['MY'],
  },
  {
    path: '/loan_status_board/:loanApplicationId/audit',
    exact: true,
    component: lazy(() => import('../pages/OpsBoardAudit')),
    name: 'OpsBoardAudit',
    isPrivate: true,
    countries: ['MY'],
  },
  {
    path: '/regenerate_facility_letter',
    exact: true,
    component: lazy(() => import('../pages/RegenerateFacilityLetter')),
    name: 'RegenerateFacilityLetter',
    isPrivate: true,
    countries: ['MY', 'TH'],
  },
  {
    path: '/view_advances',
    exact: true,
    component: lazy(() => import('../pages/ViewAdvances')),
    name: 'ViewAdvances',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/view_advances/:loanId',
    exact: true,
    component: lazy(() => import('../pages/ViewAdvances/AdvanceSummary')),
    name: 'ViewAdvanceSummary',
    isPrivate: true,
    countries: ['MY', 'ID', 'TH'],
  },
  {
    path: '/smart_activation_form',
    exact: true,
    component: lazy(() => import('../pages/SmartActivationForm')),
    name: 'SmartActivationForm',
    isPrivate: true,
    countries: ['MY'],
  },
  {
    path: '/smart_activation_form/create',
    exact: true,
    component: lazy(
      () => import('../pages/SmartActivationForm/components/BulkCreation')
    ),
    name: 'BulkCreation',
    isPrivate: true,
    countries: ['MY'],
  },
  {
    path: '/smart_activation_form/manage',
    exact: true,
    component: lazy(
      () => import('../pages/SmartActivationForm/components/LinkManagement')
    ),
    name: 'LinkManagement',
    isPrivate: true,
    countries: ['MY'],
  },
];

export default ROUTES;

export const useFilteredRoutes = () => {
  const countryCode = getCountryCodeFromUrl();
  const themeName = getTheme();
  const {email} = store.getState().login;
  const routesForTheme = ROUTES.filter((route) => {
    if (themeName === 'lender') {
      return [
        'LoginPage',
        'DashboardPage',
        'ViewAdvances',
        'ViewAdvanceSummary',
        'ApplicationDetails',
      ].includes(route.name);
    }
    return !['ViewAdvances', 'ViewAdvanceSummary'].includes(route.name);
  });

  if (RESTRICTED) {
    return routesForTheme.filter(
      (route) =>
        route.countries.includes(countryCode) &&
        (!route.admin || route.admin.includes(email))
    );
  }
  return routesForTheme.filter((route) =>
    route.countries.includes(countryCode)
  );
};
